import { Box, LayoutContentBody, LayoutContentHeader, Typography, } from '@pinwheel/origami';
import React from 'react';
import { ScreenTitleHeader } from './ScreenTitleHeader';
export function ImageTitleLayout(props) {
    var title = props.title, subtitle = props.subtitle, children = props.children;
    var titleText = typeof title === 'string' ? title : title.plaintext;
    var subtitleText = typeof subtitle === 'string' ? subtitle : subtitle === null || subtitle === void 0 ? void 0 : subtitle.plaintext;
    return (React.createElement(React.Fragment, null,
        React.createElement(LayoutContentHeader, null, children),
        React.createElement(LayoutContentBody, null,
            React.createElement(ScreenTitleHeader, { color: {
                    type: 'theme',
                    colorLegacy: 'Primary/70',
                    colorNext: 'brand/accent',
                }, variant: "header", as: "h2", align: "center", weight: "bold" }, titleText),
            subtitle && (React.createElement(Box, null,
                React.createElement(Typography, { variant: "body", color: {
                        type: 'theme',
                        colorLegacy: 'Neutral/70',
                        colorNext: 'neutral/default',
                    }, weight: "normal", align: "center" }, subtitleText))))));
}
